import { } from "lucide-react";
import LinkedinIcon from "@/components/icons/LinkedinIcon";
import { Link } from "@inertiajs/react";
import ecccImage from '@/assets/eccc-co-funded-eu.png';
import logoImage from '@/assets/logo-white.png';

export const Footer = () => {
  return (
    <footer className="bg-tech-navy text-white py-16 mt-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-8">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <div className="mb-4">
              <Link href="/">
                <img 
                  src={logoImage} 
                  alt="SheSpeaksCyber logo"
                  className="h-24 mb-4"
                />
              </Link>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Connecting event organisers with exceptional female cybersecurity speakers worldwide.
            </p>
            <div className="flex items-center">
              <a 
                href="https://linkedin.com/company/shespeakscyber" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#0077B5] hover:bg-[#0077B5]/90 text-white px-4 py-2 rounded-md transition-colors"
              >
                <LinkedinIcon className="w-4 h-4" />
                Follow us on LinkedIn
              </a>
            </div>
            <p className="text-gray-300 mt-6 max-w-md">
              Powered by <a href="https://women4cyber.eu" target="_blank" className="text-white link">Women4Cyber</a> <span className="whitespace-nowrap">and <a href="https://securepractice.co" target="_blank" className="text-white link">Secure Practice</a></span>
            </p>
          </div>

          {/* Menu and ECCC Column */}
          <div className="md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 mb-8">
              {/* Platform Menu */}
              <div>
                <h3 className="font-semibold mb-4">Platform</h3>
                <ul className="space-y-2 text-gray-300">
                  <li><a href="/speakers" className="link text-gray-200">Find Speakers</a></li>
                  <li><a href="/events" className="link text-gray-200">Calls for Speakers</a></li>
                  <li><a href="/signup" className="link text-gray-200">Sign Up</a></li>
                </ul>
              </div>

              {/* Resources + Legal Menu */}
              <div>
                <h3 className="font-semibold mb-4">Resources</h3>
                <ul className="space-y-2 text-gray-300">
                  <li><a href="/insights" className="link text-gray-200">Insights Blog</a></li>
                  <li><a href="/about" className="link text-gray-200">About Us</a></li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Legal</h3>
                <ul className="space-y-2 text-gray-300">
                  <li><a href="/terms" className="link text-gray-200">Terms of Service</a></li>
                  <li><a href="/privacy" className="link text-gray-200">Privacy Policy</a></li>
                </ul>
              </div>
            </div>

            {/* ECCC Image spanning both menu columns */}
            <div className="mt-12">
              <img 
                src={ecccImage}
                alt="Co-funded by European Union via European Cybersecurity Competence Center (ECCC)" 
                className="h-24 object-contain"
              />
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};